import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = {
  key: 0,
  class: "prefix"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 1,
  class: "sufix"
}
const _hoisted_5 = {
  key: 1,
  class: "error-message"
}

import { ref, watchEffect } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-code',
  props: {
    width: { default: "100%" },
    height: { default: "40px" },
    radius: { default: "6px" },
    background: { default: "#fff" },
    value: {},
    disabled: { type: Boolean },
    mask: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v55bcaebb": (_ctx.width),
  "v480a2ed2": (_ctx.height),
  "v58e00a3d": (_ctx.radius),
  "v1ebd2559": (_ctx.background)
}))

const props = __props;

const emit = __emit;

const internalValue = ref<string | number | null>(null);

function update(event: any) {
  let value = event.target.value;
  if (props.mask) value = props.mask(value);

  internalValue.value = value;
  emit("update:modelValue", internalValue.value);
}

watchEffect(() => {
  if (props.value) internalValue.value = props.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-input", { disabled: __props.disabled}])
  }, [
    (_ctx.$slots.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "label")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["content", { error: _ctx.$slots.error }])
    }, [
      (_ctx.$slots.prefix)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "prefix")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["input", { pref: _ctx.$slots.prefix, suf: _ctx.$slots.sufix }])
      }, [
        _withDirectives(_createElementVNode("input", _mergeProps(_ctx.$attrs, {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
          autocomplete: "off",
          disabled: __props.disabled,
          onInput: update
        }), null, 16, _hoisted_3), [
          [_vModelDynamic, internalValue.value]
        ])
      ], 2),
      (_ctx.$slots.sufix)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "sufix")
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.$slots.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "error")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})